import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  appBar: {
    background: theme.palette.background.default,
    height: 60,
    padding: 0,
    // TODO: Debería aparecer el borde sólamente cuando se haga scroll, o cuando el menú mobile o sidebar mobile estén desplegados
    // borderBottomWidth: 1,
    // borderBottomColor: theme.palette.divider,
    // [theme.breakpoints.down("sm")]: {
    //   borderBottomStyle: "solid",
    // },
  },
  toolbar: {
    padding: 0,
  },
}));

export default useStyles;
